import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var IconEnergyMarketData = function IconEnergyMarketData(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? '48px' : _ref$size,
      props = _objectWithoutProperties(_ref, ["color", "size"]);

  return (
    /*#__PURE__*/
    React.createElement(Icon, props,
    /*#__PURE__*/
    React.createElement("svg", {
      viewBox: "0 0 48 48",
      fill: "none",
      width: size,
      height: size
    },
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M35 5v2H14c-1.602 0-2.91 1.707-2.996 3.784L11 11v17h32V13h2v17H10.508l-4.62 7.464-.015.044a.41.41 0 00.001.22l.028.071a.41.41 0 00.216.198l.009.003H42v2H6l-.19-.018a2.41 2.41 0 01-1.784-3.248l.074-.17.05-.09L9 28.636V11c0-3.093 1.984-5.865 4.793-5.995L14 5h21zm3.732 7.212L40 13.48l1.45-5.39-5.4 1.44 1.268 1.268-7.388 7.387-6.63-6.63-10.128 10.138 1.415 1.414 8.712-8.723 6.631 6.63 8.802-8.802zM40 31.97v1H12v-1h28zm-5 3v1H11v-1h24z",
      fill: color
    })))
  );
};

export default IconEnergyMarketData;
export { IconEnergyMarketData };